
webpack.register(
    'components/card/social/facebook-embed/facebook-embed',
    function() {
        return require('components/card/social/facebook-embed/facebook-embed');
    },
    false
);
webpack.register(
    'components/card/social/instagram-embed/instagram-embed',
    function() {
        return require('components/card/social/instagram-embed/instagram-embed');
    },
    false
);
webpack.register(
    'components/card/social/twitter-embed/twitter-embed',
    function() {
        return require('components/card/social/twitter-embed/twitter-embed');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from=\"components/card/social/facebook-embed/facebook-embed\"/>\r\n<can-import from=\"components/card/social/instagram-embed/instagram-embed\"/>\r\n<can-import from=\"components/card/social/twitter-embed/twitter-embed\"/>\r\n\r\n<div class=\"c-card c-card__content c-card__content--social\">\r\n    {{#switch network}}\r\n\r\n        {{#case \"facebook\"}}\r\n            <facebook-embed {post-url}=\"postUrl\"/>\r\n        {{/case}}\r\n\r\n        {{#case \"instagram\"}}\r\n            <instagram-embed {post-url}=\"postUrl\" {embed}=\"embed\"/>\r\n        {{/case}}\r\n\r\n        {{#case \"twitter\"}}\r\n            <twitter-embed {post-url}=\"postUrl\"/>\r\n        {{/case}}\r\n\r\n    {{/switch}}\r\n</div>");